module.exports = __webpack_public_path__ + "static/media/persons.ab1e4513.svg";